import { Injectable } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import { EntityConditionGroup, EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { iBisAuthService, iBisSecureEditService } from '@dohu/ibis-auth';
import { iBisLanguageService, iBisServerConfig, iBisValidationService } from '@dohu/ibis-common';
import DataSource from 'devextreme/data/data_source';

@Injectable()

export class EditPatientService extends iBisSecureEditService {

	public data: DataSource;
	public gridData: DataSource

	private ft: boolean;

	constructor(auth: iBisAuthService, entity: iBisEntityService, config: iBisServerConfig, lg: iBisLanguageService, private vatValid: iBisValidationService) {
		super(auth, entity, config, lg);
		this.title = 'Pacient';
		this.validation = 'patientValidation';
		this.ft = false;

	}

	protected load(): void {
		this.data = new DataSource({ store: this.customPatientData(), paginate: true, pageSize: 50 })
		this.gridData = new DataSource({ store: this.getData(), paginate: true, pageSize: 50 })
	}

	public set filter(filter: boolean) {
		this.ft = filter;
		this.gridData = new DataSource({ store: this.getData(), paginate: true, pageSize: 50 })
	}

	public get filter() {
		return this.ft;
	}

	getById(id: any): Promise<any> {
		return new Promise((resolve, reject) => {
			this.entity.getById('Patient', id).then((res: any) => {
				if (res) {
					resolve(res);
				} else {
					reject();
				}
			}, error => this.lg.showError(error));
		});
	}

	onRemove(id: string): Promise<void> {
		return this.entity.remove('Patient', id);
	}

	onSaveEv(): Promise<any> {
		this.model.firstName = this.model.firstName.trim();
		this.model.lastName = this.model.lastName.trim();

		if (this.model.cnp && this.model.cnp.trim()) {
			return new Promise((resolve, reject) => {
				const q = new EntityQuery('Patient').eq('cnp', this.model.cnp.trim());
				if (this.model.id) {
					q.neq('id', this.model.id)
				}
				this.entity.single(q).then((res: any) => {
					if (res && Object.keys(res).length > 0) {
						reject();
						setTimeout(() => {
							this.lg.showError('CNP existent in baza de date.');
						}, 0);
					} else {
						this.entity.save('Patient', this.model.id, this.model).then((res) => {
							resolve(res);
						})

					}
				}, error => {
					//this.lg.showError(error);
					reject(error);
				});
			});
		}
		return this.entity.save('Patient', this.model.id, this.model)
	}

	reset(): void {
		this.model = this.createDefault();
	}

	createDefault() {
		return { isActiv: true };
	}

	customPatientData() {
		// solutie PORNO doar pentru invent ca nu are PatientView pentru fullName
		return new CustomStore({
			load: (loadOptions: any) => {
				const qq = new EntityQuery('Patient').eq('isActiv', true).addOrderBy(['lastName']);
				if (loadOptions.skip !== undefined) {
					qq.offset = loadOptions.skip;   // offset = skip
				}
				if (loadOptions.take !== undefined) {
					qq.limit = loadOptions.take;    // limit = take
				}
				if (/^\d+$/.test(loadOptions.searchValue)) {
					qq.addCondition('cnp', 7, '%' + loadOptions.searchValue + '%', false, false);
				}
				if (loadOptions.searchValue && loadOptions.searchValue.length && !/^\d+$/.test(loadOptions.searchValue)) {
					const value = loadOptions.searchValue;
					const splitValue = value.split(' ');
					const searchGroup = new EntityConditionGroup();
					searchGroup.useOr = true;
					const group1 = new EntityConditionGroup();
					const group2 = new EntityConditionGroup();
					const group3 = new EntityConditionGroup();
					const group4 = new EntityConditionGroup();
					// case 1: firstName + lastName or reverse order
					if (splitValue && splitValue.length > 1) {
						group1.addCondition('firstName', 7, '%' + splitValue[0] + '%', false, false);
						group1.addCondition('lastName', 7, '%' + splitValue[1] + '%', false, false);
						group2.addCondition('firstName', 7, '%' + splitValue[1] + '%', false, false);
						group2.addCondition('lastName', 7, '%' + splitValue[0] + '%', false, false);
						searchGroup.groups.push(group1);
						searchGroup.groups.push(group2);
					}
					// case 2: just firstName or lastName
					group3.addCondition('firstName', 7, '%' + value + '%', false, false);
					group3.addCondition('lastName', 7, '%' + value + '%', false, false);
					group3.useOr = true;
					searchGroup.groups.push(group3);

					// case 3: when 2 firstName are present + lastName or reverse order
					if (splitValue && splitValue.length === 3) {
						const subGroupStart = new EntityConditionGroup();
						subGroupStart.addCondition('firstName', 7, '%' + splitValue[0] + ' ' + splitValue[1] + '%', false, false);
						subGroupStart.addCondition('lastName', 7, '%' + splitValue[2] + '%', false, false);
						const subGroupEnd = new EntityConditionGroup();
						subGroupEnd.addCondition('firstName', 7, '%' + splitValue[1] + ' ' + splitValue[2] + '%', false, false);
						subGroupEnd.addCondition('lastName', 7, '%' + splitValue[0] + '%', false, false);
						group4.groups.push(subGroupStart);
						group4.groups.push(subGroupEnd);
						group4.useOr = true;
						searchGroup.groups.push(group4);
					}
					qq.conditionGroups.groups.push(searchGroup);
				}
				return this.entity.execute('FindValues', qq).then((result: any) => {
					return {
						data: result.Items || result.data || result, // adjust depending on your API response structure
						totalCount: result.totalCount || (result.Items ? result.Items.length : (result.length || 0))
					}
				})
			},
			byKey: (key: any) => {
				return this.getById(key)
			}
		})
	}
	public checkCNP = (options: any) => {
		if (options.value && options.value.length !== 0) {
			//return this.vatValid.isCPNValid(options.value);
			return this.validateCNP(options.value);
		}
		return true;
	}

	validateCNP = (cnp: string) => {
		if (!/^\d{13}$/.test(cnp)) return false;

		const control = '279146358279';
		let sum = 0;

		for (let i = 0; i < 12; i++) {
			sum += parseInt(cnp[i]) * parseInt(control[i]);
		}

		let checksum = sum % 11;
		if (checksum === 10) checksum = 1;

		if (checksum !== parseInt(cnp[12])) {
			return false;
		}

		// Birthdate validation
		const gender = parseInt(cnp[0], 10);
		const year = parseInt(cnp.substr(1, 2), 10);
		const month = parseInt(cnp.substr(3, 2), 10);
		const day = parseInt(cnp.substr(5, 2), 10);

		let fullYear = 0;
		if (gender === 1 || gender === 2) fullYear = 1900 + year;
		else if (gender === 3 || gender === 4) fullYear = 1800 + year;
		else if (gender === 5 || gender === 6) fullYear = 2000 + year;
		else if (gender === 7 || gender === 8 || gender === 9) fullYear = 2000 + year; // Temporary residents

		const birthDate = new Date(fullYear, month - 1, day);
		if (
			birthDate.getFullYear() !== fullYear ||
			birthDate.getMonth() + 1 !== month ||
			birthDate.getDate() !== day
		) {
			return false;
		}

		return true;
	}

	public reloadData(): void {
		this.data = new DataSource({ store: this.customPatientData(), paginate: true, pageSize: 50 });
	}

	private getData(): CustomStore {
		const q = new EntityQuery('Patient').addOrderBy(['lastName']);
		if (this.ft) {
			const finishedApp = new EntityQuery('Appointment').eq('statusId', 5);
			const pwConsultations = new EntityQuery('Patient').addOrderBy(['firstName', 'lastName']);
			pwConsultations.link('id', 'patientId', finishedApp);
			pwConsultations.distinct = true;
			q.except(pwConsultations);
		}
		return this.entity.store(q, false, 'id');
	}
}
